export default __webpack_public_path__ + "static/media/sad-face.4d34acff.png";